import { SelectBox } from 'devextreme-react'
import DataSource from 'devextreme/data/data_source'
import React, { Component } from 'react'
import { Col, Row } from 'reactstrap'
import cubeApiClient from '../../../BusinessObjects/cubeApiService';
import LoggedContext from '../../../BusinessObjects/LoggedContext';
import EsaedroLookupItem from '../../../Models/EsaedroLookupItem';
import { CustomColumn } from '../../../Models/Project/CustomColumn';
import { Key } from '../../../Models/Project/CustomOtherKeysToSet';
import ResourceLookupValue from '../../../Models/SysConf/ResourceLookupValue';
import { DevExtremeComponentName } from '../../../Utils/DevExtremeComponentName';
import { themeCol9, themeGroup, themeSpinner } from '../../../Utils/EsaedroTheme';
import { ResourceNames } from '../../../Utils/ResourceNames';
import DelayedDataGrid2 from '../../Esaedro/DelayedDataGrid/DelayedDataGrid2';
import { EsaedroLookupHandleChangeEvent } from '../../Esaedro/Lookup/Lookup';

interface ArticoliLookupProps {
    value:any;
    fatherObj:any;
    id:string
    isDisabled:boolean;

    otherKeysToSet: Key[] //Contiene le chiavi di un oggetto che devono essere settate oltre a quella contenente del campo id [{keyObj: '', keyValue: ''}]
    onValueChanged: (value:any) => void;

    style?:any
    className?:string;
    showClearButton?:boolean;
    isValid?:boolean;

    renderDataGrid: boolean
}

interface ArticoliLookupState{
    articoli: any[],
    articoliItemToDisplay: EsaedroLookupItem[]
    loadingArticoli: boolean,
}

export default class ArticoliLookup extends Component<ArticoliLookupProps, ArticoliLookupState> {
    static contextType = LoggedContext
    context!: React.ContextType<typeof LoggedContext>

    constructor(props: ArticoliLookupProps){
        super(props)

        this.state = {
            articoli: [],
            articoliItemToDisplay: [],
            loadingArticoli: false,
        }
    }

    componentDidMount(){
        this.getArticoli()
    }

    onValueChanged = (e:any) => {
        
        let value = undefined

        if (e.value === null || e.value === undefined || e.value === '') {
            if (this.props.renderDataGrid && e.selectedRowKeys && e.selectedRowKeys.length > 0) {
                for (var key in e.currentSelectedRowKeys[0]) {
                    if (key == e.element.attributes.columnName.nodeValue) {
                        value = e.selectedRowsData[0][key];
                    }
                }
            } else {
                value = null
            }
        } else {
            if (this.props.renderDataGrid) {
                for (var key in e.currentSelectedRowKeys[0]) {
                    if (key == e.element.attributes.columnName.nodeValue) {
                        value = e.selectedRowsData[0][key];
                    }
                }
            } else {
                value = e.value;
            }
        }

        // Creo l'evento per il padre
        let event: EsaedroLookupHandleChangeEvent = {
            value: value,
            selectedRowsData: [],
            resourceLookupValues:   this.props && this.props.otherKeysToSet
                                    ?   this.props.otherKeysToSet.map((item: Key) => {
                                            let tmpRlv: ResourceLookupValue = new ResourceLookupValue()
                                            tmpRlv.LookupName = ''
                                            tmpRlv.ValueField_Name = item.keyValue
                                            tmpRlv.ValueField_Name_Alias = item.keyObj

                                            return tmpRlv
                                        })
                                    :   [],
            fieldName: this.props.id,
            component: this.props.renderDataGrid ? DevExtremeComponentName.DataGrid : DevExtremeComponentName.SelectBox
        }

        if (this.props.renderDataGrid && e && e.selectedRowsData){
            event.selectedRowsData = e.selectedRowsData
        } else {
            let art = this.state.articoli.find(a => a.cod_art === e.value)

            if(art) event.selectedRowsData.push(art)
        }

        this.props.onValueChanged(event)
    }

    getArticoli = () => {
        this.setState({loadingArticoli: true})

        const service = new cubeApiClient()

        service.getItems(`/api/Resources/${ResourceNames.Articoli}`, this.context.tokenAPI).then(
            (data:any) => {
                //Creo gli ItemToDisplay per la DelayedDataGrid
                let articoliItemToDisplay: EsaedroLookupItem[] = []

                data.forEach((p: any) => {
                    let tmpArt: any = {
                        description: p.cod_art + ' | ' + p.des_articolo,
                        value: p.cod_art
                    }

                    articoliItemToDisplay.push(tmpArt)
                })

                this.setState({
                    articoli: data,
                    articoliItemToDisplay: articoliItemToDisplay,
                    loadingArticoli: false
                })
            },
            (error:any) => {
                this.setState({
                    articoli: [],
                    articoliItemToDisplay: [],
                    loadingArticoli: false
                })
            }
        )

    }

    render() {

        if(this.state.loadingArticoli){
            return(
                <Row className={themeGroup()}>
                    <Col className={themeCol9()}>
                        <i className={themeSpinner()}></i> Caricamento...
                    </Col>
                </Row>
            )
        }

        if(this.state.articoli.length === 0){
            return (
                <Row className={themeGroup()}>
                  <Col className={themeCol9()}>
                    Nessun dato disponibile...  
                  </Col>
                </Row>
            )
        }

        if(this.props.renderDataGrid){

            let columns: CustomColumn[] = [
                {
                    dataField: 'cod_art',
                    caption: 'Codice Articolo'
                },
                {
                    dataField: 'des_articolo',
                    caption: 'Descrizione Articolo'
                }
            ]

            return (
                <DelayedDataGrid2
                  gridColumns={columns} 
                  handleChange={this.onValueChanged} 
                  itemsToDisplay={this.state.articoliItemToDisplay}
                  fieldName={this.props.id}
                  gridValue={this.props.value}
                  valueColumnName={'cod_art'}
                  dataGridObjects={this.state.articoli}
                  gridDisabled={this.props.isDisabled}
                  isValid={this.props.isValid}
                />
            )
        }

        //Creo il DataSource perchè se no lagga quando l'utente vuole aprire la lookup
        const articoliDataSource = new DataSource({
            store: this.state.articoli,
            paginate: true,
            pageSize: 10
        });

        return (
            <SelectBox
                disabled={this.state.loadingArticoli} //|| (this.state.steps[this.state.activeStep].label === 'Prodotti' && this.state.selectBoxArticoliDisabled)
                dataSource={articoliDataSource}
                showClearButton={this.props.showClearButton}
                valueExpr='cod_art'
                displayExpr='cod_art'
                searchEnabled={true}
                searchExpr='cod_art'
                searchTimeout={1000}
                searchMode='contains'
                id={this.props.id}
                onValueChanged={this.onValueChanged}
                value={this.props.value}
                isValid={this.props.isValid}
            />
        )
    }
}
